import { render } from "./AboutContainer.vue?vue&type=template&id=25370284&scoped=true"
import script from "./AboutContainer.vue?vue&type=script&lang=js"
export * from "./AboutContainer.vue?vue&type=script&lang=js"

import "./AboutContainer.vue?vue&type=style&index=0&id=25370284&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25370284"]])

export default __exports__